import VRInUse from '../../assets/img/vrpad-doctor-vr-app-square.webp';
import { useTranslation } from 'react-i18next';

const Studies = () => {
    const { t } = useTranslation();

    const studies = [
        {
            emoji: '🧠',
            title: t('studies.items.item1.title'),
            source: t('studies.items.item1.source'),
            link: t('studies.items.item1.link')
        },
        {
            emoji: '💡',
            title: t('studies.items.item2.title'),
            source: t('studies.items.item2.source'),
            link: t('studies.items.item2.link')
        },
        {
            emoji: '📊',
            title: t('studies.items.item3.title'),
            source: t('studies.items.item3.source'),
            link: t('studies.items.item3.link')
        }
    ];

    return (
        <div className="bg-[#fbf9ed] p-8 mx-auto relative min-h-[740px] h-full rounded-[40px] flex flex-col text-center lg:text-left lg:flex-row gap-12 items-center"
            style={{ maxWidth: "var(--width-container)" }} id='vyuziti'>

            <img src={VRInUse} alt={t('studies.imageAlt')} className="rounded-[20px] lg:max-w-[45%]" />

            <div className="flex flex-col gap-8 justify-center items-start lg:max-w-[50%]">
                <h2 className="text-3xl font-bold mb-4 md:text-[36px]">
                    {t('studies.title')} <span className="text-primary">{t('studies.highlight')}</span>
                </h2>

                <div className="space-y-4 flex flex-col gap-15 md:gap-5 text-left">
                    {studies.map((study, index) => (
                        <div key={index} className="flex items-center md:items-start gap-4 flex-col sm:flex-row">
                            <span className="text-5xl md:text-3xl">{study.emoji}</span>
                            <div>
                                <p className="font-semibold">{study.title}</p>
                                <a href={study.link} target="_blank" rel="noopener noreferrer">
                                    {study.source}
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <a href="#kontakt" className='btn'>{t('studies.tryButton')}</a>

            </div>
        </div>
    );
}

export default Studies;
